import React from 'react';
import { Box, Typography } from '@mui/material';

interface ActiveInjectionAlertProps {
  showAlert: boolean;
}

export default function ActiveInjectionAlert({ showAlert }: ActiveInjectionAlertProps) {
  if (!showAlert) {
    return null;
  }

  return (
    <Box>
      <Typography variant="body1" textAlign="center" sx={{ marginBottom: 2, fontWeight: 'bold' }}>
        ¡Atención! Cobro en proceso
      </Typography>
      <Typography variant="caption" textAlign="justify" component="div">
        Actualmente existe un
        {' '}
        <b>cobro en proceso a la cuenta asociada a tu</b>
        {' '}
        <Typography variant="inherit" color="secondary" sx={{ fontWeight: 'bold' }} component="span">PAC</Typography>
        .
        {' '}
        Si realizas un pago ahora, podría duplicarse,
        aunque de todas formas se te devolvería el cobro extra si es el caso.
      </Typography>
    </Box>
  );
}
